// Search only the visible group name; row identity and action metadata stay intact.
export function matchesGroupName(query, row) {
  return row[1].toLowerCase().includes((query || "").trim().toLowerCase());
}
